import { FC } from "react";

import { GHOST_PREVIEW_OPACITY } from "../../LiveFormEditor/LivePreview/ghostPreview.constant";
import { useIsGhostPreview } from "../../LiveFormEditor/LivePreview/useIsGhostPreview";
import { useFormV2Context } from "../context/FormV2Context";

import { MobileThemedFormBanner } from "@/features/FormV2/sharedComponents/MobileThemedFormBanner";
import { IS_GENERATING_BANNER_SRC } from "@/features/FormV2/sharedComponents/ThemedFormBanner";
import { GeneratingBannerPlaceholder } from "@/features/FormV2/Step1/GeneratingBannerPlaceholder";
import { STEP_TO_ELEMENT_ID } from "@/features/LiveFormEditor/AnimatePreview/Arrow/ArrowContext";

export const MobileFormV2Banner: FC = () => {
  const { formObject } = useFormV2Context();
  const isGhostPreview = useIsGhostPreview("FormV2Banner");

  if (formObject?.bannerUrl === IS_GENERATING_BANNER_SRC) {
    return <GeneratingBannerPlaceholder />;
  }

  if (formObject?.bannerUrl) {
    return (
      <MobileThemedFormBanner
        id={STEP_TO_ELEMENT_ID["banner"]}
        imageSrc={formObject.bannerUrl!}
        videoSrc={undefined}
        data-test="banner-image"
        sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
      />
    );
  }

  if (formObject?.bannerVideoUrl) {
    return (
      <MobileThemedFormBanner
        id={STEP_TO_ELEMENT_ID["banner"]}
        videoSrc={formObject.bannerVideoUrl!}
        imageSrc={undefined}
        data-test="banner-video"
        sx={{ opacity: isGhostPreview ? GHOST_PREVIEW_OPACITY : 1 }}
      />
    );
  }

  return null;
};
